import {Component, OnInit} from '@angular/core';
import {BlockAbstractComponent} from '@gallaghercp/core-frontend';

@Component({
    standalone: false,
    selector: 'core-block-button',
    templateUrl: './block-button.component.html',
})

export class BlockButtonComponent extends BlockAbstractComponent implements OnInit {

}
